import styled from 'styled-components';

export default styled.div`
  gap: 12px;

  .section {
    display: flex;
    gap: 10px;

    .title {
      flex: 1;
      overflow: hidden;
      max-width: 110px;

      label {
        margin-bottom: 0px;
        font-size: 12px;
        font-weight: 500;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: 100%;
        color: #595959;
      }
    }

    .flex-1 {
      flex: 1;
    }

    .progress-cont {
      flex: 1;
      display: flex;
      height: 10px;

      .progress-bar {
        margin-top: 6px;
        background: #ECECEC;
        border-radius: 0px 9px 9px 0;
        height: 10px;
        flex: 1;

        div {
          height: 20px;
          border-radius: 0px 9px 9px 0;
        }
      }
    }

    .percentage {
      font-size: 12px;
      font-weight: 500;
      width: 45px;
      text-align: right;
      color: #6F7C89;
    }
  }
`;
